import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const supportedLanguage = ["en", "de", "zh", "fi", "it"];

const getSupportedLanguage = (lang: string) => {
  return supportedLanguage.includes(lang) ? lang : "en";
};
export const userLanguage = navigator.language
  ? getSupportedLanguage(navigator.language.split("-")[0])
  : "en";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: userLanguage,
  resources: {
    en: {
      translations: require("./locales/en/translations.json"),
    },
    de: {
      translations: require("./locales/de/translations.json"),
    },
    zh: {
      translations: require("./locales/zh/translations.json"),
    },
    fi: {
      translations: require("./locales/fi/translations.json"),
    },
    it: {
      translations: require("./locales/it/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = supportedLanguage;

export default i18n;
